/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetInventoryMissingFieldResponse } from './AssetInventoryMissingFieldResponse';
import {
    AssetInventoryMissingFieldResponseFromJSON,
    AssetInventoryMissingFieldResponseFromJSONTyped,
    AssetInventoryMissingFieldResponseToJSON,
    AssetInventoryMissingFieldResponseToJSONTyped,
} from './AssetInventoryMissingFieldResponse';
import type { AssetInventoryCompletenessSection } from './AssetInventoryCompletenessSection';
import {
    AssetInventoryCompletenessSectionFromJSON,
    AssetInventoryCompletenessSectionFromJSONTyped,
    AssetInventoryCompletenessSectionToJSON,
    AssetInventoryCompletenessSectionToJSONTyped,
} from './AssetInventoryCompletenessSection';

/**
 * 
 * @export
 * @interface AssetInventorySectionCompletenessResponse
 */
export interface AssetInventorySectionCompletenessResponse {
    /**
     * 
     * @type {AssetInventoryCompletenessSection}
     * @memberof AssetInventorySectionCompletenessResponse
     */
    section: AssetInventoryCompletenessSection;
    /**
     * 
     * @type {boolean}
     * @memberof AssetInventorySectionCompletenessResponse
     */
    hasData: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetInventorySectionCompletenessResponse
     */
    hasWarning: boolean;
    /**
     * 
     * @type {Array<AssetInventoryMissingFieldResponse>}
     * @memberof AssetInventorySectionCompletenessResponse
     */
    missingFields: Array<AssetInventoryMissingFieldResponse>;
}



/**
 * Check if a given object implements the AssetInventorySectionCompletenessResponse interface.
 */
export function instanceOfAssetInventorySectionCompletenessResponse(value: object): value is AssetInventorySectionCompletenessResponse {
    if (!('section' in value) || value['section'] === undefined) return false;
    if (!('hasData' in value) || value['hasData'] === undefined) return false;
    if (!('hasWarning' in value) || value['hasWarning'] === undefined) return false;
    if (!('missingFields' in value) || value['missingFields'] === undefined) return false;
    return true;
}

export function AssetInventorySectionCompletenessResponseFromJSON(json: any): AssetInventorySectionCompletenessResponse {
    return AssetInventorySectionCompletenessResponseFromJSONTyped(json, false);
}

export function AssetInventorySectionCompletenessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetInventorySectionCompletenessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'section': AssetInventoryCompletenessSectionFromJSON(json['section']),
        'hasData': json['hasData'],
        'hasWarning': json['hasWarning'],
        'missingFields': ((json['missingFields'] as Array<any>).map(AssetInventoryMissingFieldResponseFromJSON)),
    };
}

export function AssetInventorySectionCompletenessResponseToJSON(json: any): AssetInventorySectionCompletenessResponse {
    return AssetInventorySectionCompletenessResponseToJSONTyped(json, false);
}

export function AssetInventorySectionCompletenessResponseToJSONTyped(value?: AssetInventorySectionCompletenessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'section': AssetInventoryCompletenessSectionToJSON(value['section']),
        'hasData': value['hasData'],
        'hasWarning': value['hasWarning'],
        'missingFields': ((value['missingFields'] as Array<any>).map(AssetInventoryMissingFieldResponseToJSON)),
    };
}

